import React from 'react';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../components/layout';
import { WorkspaceList } from '../../components/workspace';
import { useDocumentTitle } from '../../hooks';
import './WorkspacesPage.css';

/**
 * WorkspacesPage Component
 * Main page for displaying and managing workspaces
 * Implements Requirements 2.1, 2.2, 2.3, 2.4
 */
export const WorkspacesPage: React.FC = () => {
  const { t } = useTranslation();
  
  // Set document title
  useDocumentTitle('pageTitles.workspaces');

  return (
    <MainLayout title={t('workspace.title')}>
      <div className="workspaces-page">
        <WorkspaceList />
      </div>
    </MainLayout>
  );
};
